// Bundle discount tiers — mirrors backend BUNDLE_TIERS (also fetched from /api/meta
// on load if we want to override client defaults).
export const BUNDLE_TIERS = [
  { min_qty: 6, pct: 10 },
  { min_qty: 3, pct: 5 },
];

export function bundleForQty(totalQty) {
  for (const t of BUNDLE_TIERS) {
    if (totalQty >= t.min_qty) return { pct: t.pct, min_qty: t.min_qty };
  }
  return { pct: 0, min_qty: 0 };
}

export function nextBundleTier(totalQty) {
  const sorted = [...BUNDLE_TIERS].sort((a, b) => a.min_qty - b.min_qty);
  for (const t of sorted) {
    if (totalQty < t.min_qty) return { add_qty: t.min_qty - totalQty, pct: t.pct };
  }
  return null;
}

export function bundleDiscount(subtotal, totalQty) {
  const b = bundleForQty(totalQty);
  return {
    pct: b.pct,
    amount: b.pct ? Math.round(subtotal * b.pct) / 100 : 0,
    min_qty: b.min_qty,
  };
}
